module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-popup', {
    staticClass: "AddContact"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "subNavTitle": "New Contact",
      "closePopup": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layoutSubtitle"
  }), _vm._v(" "), _c('f7-list', {
    attrs: {
      "form": ""
    }
  }, [_c('f7-list-item', [_c('f7-label', [_vm._v("Account Name")]), _vm._v(" "), _c('f7-input', {
    attrs: {
      "name": "label",
      "type": "text",
      "placeholder": "Label"
    },
    model: {
      value: (_vm.label),
      callback: function($$v) {
        _vm.label = $$v
      },
      expression: "label"
    }
  })], 1), _vm._v(" "), _c('f7-list-item', [_c('f7-label', [_vm._v("User Name")]), _vm._v(" "), _c('f7-input', {
    attrs: {
      "name": "username",
      "placeholder": "Name",
      "type": "text"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), _c('f7-list-item', [_c('f7-label', [_vm._v("Identifier")]), _vm._v(" "), _c('f7-input', {
    attrs: {
      "name": "alias",
      "type": "email",
      "placeholder": "Identifier"
    },
    model: {
      value: (_vm.alias),
      callback: function($$v) {
        _vm.alias = $$v
      },
      expression: "alias"
    }
  })], 1), _vm._v(" "), _c('f7-list-item', [_c('f7-label', [_vm._v("Iban")]), _vm._v(" "), _c('f7-input', {
    attrs: {
      "name": "iban",
      "type": "text",
      "placeholder": "Iban"
    },
    model: {
      value: (_vm.iban),
      callback: function($$v) {
        _vm.iban = $$v
      },
      expression: "iban"
    }
  })], 1)], 1), _vm._v(" "), _c('f7-button', {
    staticClass: "blueConfirmationButton",
    attrs: {
      "icon-f7": "add_round"
    },
    on: {
      "click": _vm.addContact
    }
  }, [_vm._v("Create")]), _vm._v(" "), _c('f7-button', {
    staticClass: "blueConfirmationButton",
    attrs: {
      "disabled": "",
      "icon-f7": "cloud_upload"
    }
  }, [_vm._v("Import Contacts")])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f3a45236", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3a45236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/popups/contacts/CMAddContact.vue
// module id = 1735
// module chunks = 2